import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgShapes = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M12 0c.425 0 .817.224 1.027.588l5.409 9.333c.209.361.207.805-.004 1.165-.212.36-.602.58-1.024.58H6.592c-.422 0-.812-.22-1.024-.58a1.153 1.153 0 0 1-.004-1.165L10.973.588C11.183.224 11.575 0 12 0Zm3.37 9.333L12 3.518 8.63 9.333h6.74ZM18.76 16c-1.586 0-2.873 1.268-2.873 2.833 0 1.565 1.287 2.834 2.874 2.834 1.586 0 2.873-1.269 2.873-2.834 0-1.564-1.287-2.833-2.873-2.833Zm-5.239 2.833c0-2.853 2.346-5.166 5.24-5.166 2.893 0 5.239 2.313 5.239 5.166C24 21.687 21.654 24 18.76 24c-2.893 0-5.239-2.313-5.239-5.167ZM2.366 16.167c0-.092.076-.167.17-.167h5.408c.093 0 .169.075.169.167V21.5a.168.168 0 0 1-.17.167H2.536a.168.168 0 0 1-.169-.167v-5.333Zm.17-2.5c-1.401 0-2.536 1.119-2.536 2.5V21.5C0 22.88 1.135 24 2.535 24h5.409c1.4 0 2.535-1.12 2.535-2.5v-5.333c0-1.381-1.135-2.5-2.535-2.5H2.535Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgShapes);
export default ForwardRef;
